import { h } from "preact";
import { useState } from "preact/hooks";
import { Grid, Typography } from "@mui/material";

export default function MentionsLegales() {
	return (
		<div style="margin: 30px">
			<Typography variant="h1">BKEYS LIMITED</Typography>
			<Typography variant="h4">GBC private company limited au capital de 1000€</Typography>
			<Typography variant="h6">Company N° 174440</Typography>
			<p></p>
			<Typography variant="body1">Adresse:&nbsp;</Typography>

			<Typography variant="body2">Premier Business Center</Typography>
			<Typography variant="body2">10th Floor - Sterling Tower 14 Poudrière Street Port Louis, 11302 MAURITIUS </Typography>

			<p>
				<Typography variant="body1" display="inline">
					Email:&nbsp;
				</Typography>
				<a href="mailto:contact@bkeys.com>">
					<Typography variant="body1" display="inline">
						contact@bkeys.com
					</Typography>
				</a>
			</p>
		</div>
	);
}
